module.exports = __webpack_public_path__ + "688623cbda80680d2daeb5ab07b424f3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/projekte/lankenau07.jpg
// module id = 663
// module chunks = 0